import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getExportSchedulesData(context) {
            const response = await Vue.axios.get(`${URL_API}exportschedule`);
            let data = response["data"];
            context.commit("updateExportSchedulesData", data);
        },
        async createExportScheduleData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}exportschedule/store`, body, config);
            context.dispatch("getExportSchedulesData");
        },
        async pushExportScheduleData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}exportschedule/update`, body, config);
            context.dispatch("getExportSchedulesData");
        },
        async destroyExportScheduleData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}exportschedule/destroy`, body, config);
            context.dispatch("getExportSchedulesData");
        }
    },
    mutations: {
        updateExportSchedulesData(state, exportSchedulesData) {
            state.exportSchedulesData = exportSchedulesData;
        }
    },
    state: {
        exportSchedulesData: []
    },
    getters: {
        allExportSchedulesData(state) {
            return state.exportSchedulesData;
        }
    }
};